import { TICK_MS } from "@pd/shared";
import type { Observation } from "@pd/shared";
import { noteChat } from "./chatBubbles.js";
import type { ChatBubbleStore } from "./chatBubbles.js";

/** Cosmetic speech stays separate from player chat and the message log.
 * Replayed/recovered events retain only their unexpired tick duration. */
export function ingestEnemySpeech(bubbles: ChatBubbleStore, seen: Map<number, number>, obs: Observation,
  tick: number, events: readonly unknown[], now: number): void {
  for (const id of bubbles.keys()) {
    if (!obs.enemies.some((e) => e.id === id && e.alive)) bubbles.delete(id);
  }
  for (const raw of events) {
    if (!raw || typeof raw !== "object") continue;
    const e = raw as { type?: string; tick?: number; enemyId?: number; message?: string; durationTicks?: number };
    if (e.type !== "enemy-speech" || e.tick === undefined || e.enemyId === undefined || !e.message || e.durationTicks === undefined) continue;
    if ((seen.get(e.enemyId) ?? -1) >= e.tick) continue;
    seen.set(e.enemyId, e.tick);
    const remaining = e.tick + e.durationTicks - tick;
    if (remaining > 0 && obs.enemies.some((enemy) => enemy.id === e.enemyId && enemy.alive)) {
      noteChat(bubbles, e.enemyId, e.message, now, remaining * TICK_MS);
    }
  }
}
